import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { StaffService } from '@ascschool/services/user/staff.service';
import { Staff } from '@ascschool/model/user/staff.model';
import { TbColumm } from '@ascschool/interface/table/column';
import { TbOption } from '@ascschool/interface/table/option';
import { DatePipe } from '@angular/common';
import { Field, ModeFieldDate, TypeField } from '@ascschool/interface/form/field';
import { TblBtnRowExtend } from '@ascschool/interface/button/table-btn-row-extend';
import { BtnOptionExtend, Nztheme } from '@ascschool/interface/button/btn-option-extend';
import { Observable, Subscription } from 'rxjs';
import { MailService } from '@ascschool/services/mail/mail.service';
import { map } from 'rxjs/operators';
import { AddTagComponent } from '../pop-up/add-tag/add-tag.component';
import { MailDetailComponent } from '../pop-up/mail-detail/mail-detail.component';
import { PopUpComposeComponent } from '../pop-up/pop-up-compose/pop-up-compose.component';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-mail-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  tagIdRes: number = 0;
  heightModal: string;
  widthModal: string;
  @Input('mode') mode: 'inbox' | 'outbox' | 'draft' | 'deleted' | 'tag' = 'inbox';
  @Input('tagId') tagId = 0;
  @Output() numberDraft = new EventEmitter();
  get breadcrumbs(): string[] {
    return ['Hộp thư'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  getSenderReceiverACFn: (value: any) => Observable<any>;
  getTagACFn: (value: any) => Observable<any>;
  constructor(
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private modalService: NzModalService,
    public utilService: UtilsService,
    private service: WardService,
    private staffService: StaffService,
    private mailService: MailService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
  }
  formFeildItems: Field[] = [
    new Field('Tiêu đề', TypeField.INPUT, 'SearchTerm', 'Nhập tìm kiếm', false, null, 6),
    new Field('Người gửi', TypeField.SELECT_AUTOCOMPLETE, 'SenderReceiver', 'Chọn người gửi', false, null, 6, null,null , null, null, null,),
    new Field('Từ ngày', TypeField.DATETIME, 'FromDate', 'Chọn thời điểm', false, false, 6, null, ModeFieldDate.DATE),
    new Field('Đến ngày', TypeField.DATETIME, 'ToDate', 'Chọn thời điểm', false, false, 6, null, ModeFieldDate.DATE),
    new Field('Đính kèm', TypeField.SELECT, 'HasAttachment', 'Chọn thời điểm',false, null, 6, "", null, [{lable: "Có", key: true},{lable: "Không", key:false}, {lable: "Tất cả", key:""}],),
    new Field('Nhãn', TypeField.SELECT_AUTOCOMPLETE, 'Tag', 'Chọn nhãn',false, null, 6, null,null,null, null,null),
  ];
  dataSearch: any;
  // thông tin cột table
  columns: TbColumm[] = [
    {
      columnName: 'Tệp',
      colIconTheme: Nztheme.OUTLINE,
      width: '50px',
      align: 'center',
      key: 'hasAttachment',
      buttonList: [
        new TblBtnRowExtend('Tệp', 'paper-clip', this.downloadFile.bind(this), Nztheme.OUTLINE)
      ],
    },
    {
      columnName: 'Nhãn',
      colIconTheme: Nztheme.OUTLINE,
      width: '70px',
      align: 'center',
      key: 'color',
      display: true,
      buttonList: [
        new TblBtnRowExtend('Nhãn', 'tag', this.hanlderAddTag.bind(this), Nztheme.OUTLINE)
      ],
      isShowButton: true,
    },
    {
      columnName: 'Người gửi/nhận',
      width: '200px',
      align: 'left',
      key: 'fullName',
      sortFn: (a, b) => a.fullName.localeCompare(b.fullName),
      priority: 3,
      isLink: true,
      handlerLink:  this.openMailDetail.bind(this),
      isTooltip: true,
    },
    {
      columnName: 'Tiêu đề',
      width: '',
      align: 'left',
      key: 'subject',
      sortFn: (a, b) => a.subject.localeCompare(b.subject),
      priority: 2,
      isLink: true,
      handlerLink:  this.openMailDetail.bind(this),
      isTooltip: true,
    },
    {
      columnName: 'Thời gian',
      width: '150px',
      align: 'left',
      key: 'time',
      isPipe: true,
      pipe: DatePipe,
      agrPipe: ['dd/MM/yy hh:mm'],
      sortFn: (a, b) => a.time.localeCompare(b.time),
      priority: 1
    }
  ];
  // tùy chọn table
  options: TbOption = {
    nzPageSizeOptions: [50, 100, 200],
    nzPageSize: 50,
    total: 0,
    columns: this.columns,
    numbernzLeft: 2,
    numbernzRight: 1,
    nzPageIndex: 1,
    isIndexCol: false,
    isBtnCol: false,
    isInfoBtn: true,
    isEditBtn: true,
    isScrollTable: true,
    isCheckBoxCol: true
  };
  pageOptBtn: BtnOptionExtend[] = [];
  pageOptBtn_1: BtnOptionExtend[] = [
    new BtnOptionExtend(
      'Làm mới',
      'reload',
      this.reload.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      null,
    ),
    new BtnOptionExtend(
      'Xóa',
      'delete',
      this.hanlderDeleteOutBox.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      'text-red-600'
    )
  ];
  pageOptBtn_3: BtnOptionExtend[] = [
    new BtnOptionExtend(
      'Làm mới',
      'reload',
      this.reload.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      null,
    ),
    new BtnOptionExtend(
      'Xóa',
      'delete',
      this.hanlderDeleteDeleted.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      'text-red-600'
    )
  ];
  pageOptBtn_2: BtnOptionExtend[] = [
    new BtnOptionExtend(
      'Làm mới',
      'reload',
      this.reload.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      null,
    ),
    new BtnOptionExtend(
      'Gán nhãn',
      'tags',
      this.hanlderAddListTag.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      'text-violet-600',
      true
    ),
    new BtnOptionExtend(
      'Bỏ nhãn',
      'close-square',
      this.hanlderDeleteListTag.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      null,
      true
    ),
    new BtnOptionExtend(
      'Xóa',
      'delete',
      this.hanlderDeleteInbox.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      'text-red-600'
    ),
  ];
  // Text
  headerText = 'Hộp thư đến';
  titlePopup: string;
  senderReceiverNameText = '';
  senderReceiverTimeText = '';
  detailDialogRef: NzModalRef;
  listCheckId: any = [];
  currentUser: any;
  isResizdePopup: boolean;
  shortcuts: ShortcutInput[] = [];
  lstMail: any = [];
  commonFilter = new CommonFilter();
  searchTerm = '';
  pageIndex = 1;
  pageSize = this.options.nzPageSizeOptions[0];
  listPersonSelected: number[] = [];
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation = 50;
  dataTable: any = [];
  tags: any[] = [];
  loading: boolean;
  private eventsSubscription: Subscription;
  @Input() events: Observable<any>;
  mailDetail: any = [];
  fileList: NzUploadFile[] = [];
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.options.nzPageSizeOptions[0];
    this.reload();
    this.initText();
    this.initOptionBtn();
    this.loadSenderReceiver();
    this.loadTag();
  }
  lstSenderReceiver: any[] = [];
  initText() {
    switch (this.mode) {
      case 'inbox':
        this.headerText = 'Hộp thư đến';
        this.columns[2].columnName = 'Người gửi/nhận';
        this.columns[4].columnName = 'Thời gian';
        this.columns[1].display = true;
        break;
      case 'outbox':
        this.headerText = 'Thư đã gửi';
        this.columns[2].columnName = 'Người nhận';
        this.columns[4].columnName = 'Thời gian gửi';
        this.columns[1].display = false;
        this.formFeildItems[5].disable = true;
        break;
      case 'draft':
        this.headerText = 'Thư nháp';
        this.columns[2].columnName = 'Người nhận';
        this.columns[4].columnName = 'Thời gian lưu';
        this.columns[1].display = false;
        this.columns[2].handlerLink = this.openNewMail.bind(this);
        this.columns[3].handlerLink = this.openNewMail.bind(this);
        this.formFeildItems[5].disable = true;
        break;
      case 'deleted':
        this.headerText = 'Thư đã xóa';
        this.columns[2].columnName = 'Người gửi/nhận';
        this.columns[4].columnName = 'Thời gian';
        this.columns[1].display = false;
        this.formFeildItems[5].disable = true;
        break;
      case 'tag':
        this.headerText = 'Hộp thư đến';
        this.columns[3].columnName = 'Người gửi';
        this.columns[4].columnName = 'Thời gian nhận';
        this.columns[1].display = false;
      break;
    }
  }
  initOptionBtn() {
    if (this.mode === 'inbox') {
      this.pageOptBtn = this.pageOptBtn_2;
    }else if(this.mode === 'deleted'){
      this.pageOptBtn = this.pageOptBtn_3;
    }else{
      this.pageOptBtn = this.pageOptBtn_1;
    }
  }
  reload() {
    switch (this.mode) {
      case 'inbox':
        this.loagTagAndInbox();
        this.eventsSubscription = this.events.subscribe((res) => {
          this.resetValueSearch();
          this.tagIdRes = res.id;
          if(res.id === 0){
            this.headerText = 'Hộp thư đến';
            this.formFeildItems[5].value = '';
            this.formFeildItems[5].disable = false;
            this.loagTagAndInbox();
          }else{
            this.headerText = 'nhãn: ' + res.name;
            this.formFeildItems[5].value =  {id: res.id,  text: res.name};
            this.formFeildItems[5].disable = true;
            this.loagTagAndInbox();
          }
        });
        break;
      case 'outbox':
        this.loadOutbox();
        break;
      case 'draft':
        this.loadDraftItems();
        break;
      case 'deleted':
        this.loadDeletedItems();
        break;
    }
  }
  initData() {
    switch (this.mode) {
      case 'inbox':
      case 'tag':
        this.loadSenderReceiver();
        this.loadTag();
        break;
      case 'outbox':
      case 'draft':
        this.loadListReceiver();
        break;
      case 'deleted':
        this.loadListSender();
        break;
    }
  }
  getCountInboxUnRead(){
    this.mailService.getCountUnread().subscribe((res: number)=>{
      this.mailService.refreshCountInboxUnread(res);
    });
  }
  loagTagAndInbox(){
    this.mailService.getTagPaging({ PageIndex: 1, PageSize: 100 }).subscribe((res)=>{
      this.loadInbox(res.results);
      this.getCountInboxUnRead();
    });
  }
  loadInbox(tags:any[]) {
    if(this.tagIdRes >= 0){
      this.commonFilter.Tag = this.tagIdRes;
    }
    this.mailService.getMyInbox(this.commonFilter).subscribe((response: any) => {
      response.results.forEach(element => {
        tags.forEach(tag =>{
          if(element.tagId === tag.id){
            element.color = tag.color;
            element.tagName = tag.name;
          }
        })
      });
      this.lstMail = response.results ? response.results : [];
      this.options.total = response && response.rowCount ? response.rowCount : 0;
    });
  }
  resetValueSearch(){
    this.formFeildItems.forEach(item=>{
      item.value = '';
    });
    this.commonFilter = new CommonFilter;
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.options.nzPageSizeOptions[0];
  }
  hanlderDeleteInbox(){
    if(this.listCheckId.length > 0){
      this.mailService.moveMailInboxToTrash(this.listCheckId).subscribe(
        () => {
          this.msg.success('Xóa thư thành công!');
          this.reload();
        },()=>{
          this.msg.error('Xóa thư thất bại vui lòng thử lại.');
      });
    }else{
      this.msg.warning('Chưa chọn thư để xóa!');
    }
  }
  hanlderDeleteOutBox(){
    this.titlePopup= 'Xóa thư';
    this.isResizdePopup = false;
    if(this.listCheckId.length > 0){
      this.detailDialogRef = this.modalService.create({
        nzTitle: this.titlePopupElement,
        nzContent: ConfirmComponent,
        nzComponentParams: {
          description: 'thư đã chọn'
        },
        nzStyle: { top: '20px' },
        nzMaskClosable: false
      });
      this.detailDialogRef.afterClose.subscribe((result) => {
        if (result) {
          this.mailService.moveMailOutboxToTrash(this.listCheckId).subscribe(
            () => {
              this.msg.success('Xóa thư thành công!');
              this.reload();
            },()=>{
              this.msg.error('Xóa thư thất bại vui lòng thử lại.');
          });
        }
      });
    }else{
      this.msg.warning('Chưa chọn thư để xóa!');
    }
  }
  hanlderDeleteDeleted(){
    this.titlePopup= 'Xóa thư';
    this.isResizdePopup = false;
    const listInBox = [];
    const listOutBox = [];
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: 'thư đã chọn'
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false
    });
    this.detailDialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.listCheckId.forEach(element => {
          this.lstMail.forEach(mail =>{
            if(element === mail.id && mail.source === 'Inbox'){
              listInBox.push(element);
            }else if(element === mail.id && mail.source === 'Outbox'){
              listOutBox.push(element);
            }
          })
        });
        if (listInBox.length > 0) {
          this.mailService.deleteMailInboxMulti(listInBox).subscribe(
            () => {
              this.reload();
              // this.msg.success('Xóa thư thành công!');
            },()=>{
              this.msg.error('Xóa thư thất bại vui lòng thử lại.');
          });
        }
        if (listOutBox.length > 0) {
          this.mailService.deleteMailOutboxMulti(listOutBox).subscribe(
            () => {
              this.reload();
            },()=>{
              this.msg.error('Xóa thư thất bại vui lòng thử lại.');
          });
        }
      }
    });
  }
  loadOutbox() {
    this.mailService.getMyOutbox(this.commonFilter).subscribe((response: any) => {
      this.lstMail = response.results ? response.results : [];
      this.options.total = response && response.rowCount ? response.rowCount : 0;
    });
  }
  loadDraftItems() {
    this.mailService.getMyDraftItems(this.commonFilter).subscribe((response: any) => {
      this.lstMail = response.results ? response.results : [];
      this.options.total = response && response.rowCount ? response.rowCount : 0;
    });
  }
  loadDeletedItems() {
    this.mailService.getMyDeletedItems(this.commonFilter).subscribe((response: any) => {
      this.lstMail = response.results ? response.results : [];
      this.options.total = response && response.rowCount ? response.rowCount : 0;
    });
  }
  loadListReceiver() {
    this.mailService.getMyOutboxListReceiver().subscribe((response: any) => {
      this.lstSenderReceiver = response ? response : [];
    });
  }
  loadListSender() {
    this.mailService.getMyInboxListSender().subscribe((response: any) => {
      this.lstSenderReceiver = response ? response : [];
    });
  }
  hanlderDeleteListTag(event) {
    this.mailService.removeTag(this.listCheckId).subscribe(
      () => {
        this.msg.success('Xóa nhãn thành công!');
        this.reload();
      },()=>{
        this.msg.error('Xóa nhãn thất bại vui lòng thử lại.');
    });
  }
  loadSenderReceiver() {
    this.getSenderReceiverACFn =
      (value: any) => this.mailService.getMyInboxListSender().pipe(
      map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.value })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    this.formFeildItems[1].autoComplete = this.getSenderReceiverACFn;
  }
  loadTag() {
    this.getTagACFn =
      (value: any) => this.mailService.getMyTags().pipe(
      map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    this.formFeildItems[5].autoComplete = this.getTagACFn;
  }
  downloadFile(event) {
  }
  search(event) {
    this.commonFilter = new CommonFilter();
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSize;
    Object.keys(event).forEach((key) => {
      this.commonFilter[key] = event[key];
    });
    if(this.mode !== 'inbox'){
      this.reload();
    }else{
      this.loagTagAndInbox();
    }
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.options.nzPageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.options.nzPageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateSizeTable();
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => this.addpersonnel(),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  checkCaculateSizeTable() {
    setTimeout(() => {
      this.options.height = this.heightfnc();
      this.options.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation,
      10
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    if (maxHeight > 950) {
      return 700 + (maxHeight - 860);
    } else {
      return 700 - (860 - maxHeight);
    }
  }
  onResize() {
    this.checkCaculateSizeTable();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.checkCaculateSizeTable();
  }
  edit(item: any) {
    // this.detailDialogRef = this.modalService.create({
    //   nzTitle: 'Thông tin nhân sự',
    //   nzContent: PopupTtnsComponent,
    //   nzStyle: { top: '30px' },
    //   nzMaskClosable: false,
    //   nzBodyStyle: {
    //     overflow: 'auto',
    //     maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
    //     height: this.caculateHeightPopup(window.innerHeight) + 'px',
    //   },
    //   nzComponentParams: {
    //     value: item
    //   },
    //   nzWidth: 1500,
    // });
    // // const instance = dialogRef.getContentComponent();
    // dialogRef.afterClose.subscribe((result) => {
    //   if (result) {
    //     this.reload();
    //   }
    // });
    // // item la 1 danh muc du thi
  }
  addpersonnel() {
    // this.detailDialogRef = this.modalService.create({
    //   nzTitle: 'Thông tin nhân sự',
    //   nzContent: PopupThemTtnsComponent,
    //   nzStyle: { top: '20px' },
    //   nzMaskClosable: false,
    //   nzBodyStyle: {
    //     overflow: 'auto',
    //     maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
    //     height: this.caculateHeightPopup(window.innerHeight) + 'px',
    //   },
    //   nzWidth: 1500
    // });
    // // const instance = dialogRef.getContentComponent();
    // dialogRef.afterClose.subscribe((result) => {
    //   if (result) {
    //     this.reload();
    //   }
    // });
  }
  delete(item: Staff) {
    this.titlePopup= 'Xóa thư';
    this.isResizdePopup = false;
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: item.fullName
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false
    });
    this.detailDialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.service.deleteWard(item.id).subscribe((res: any) => {
          this.notification(res);
          this.reload();
        });
      }
    });
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  deleteMany() {
    this.titlePopup= 'Xóa thư';
    this.isResizdePopup = false;
    this.listCheckId.forEach((element) => {
      this.listPersonSelected.push(element);
    });
    if (this.listPersonSelected.length > 0) {
      this.detailDialogRef  = this.modalService.create({
        nzTitle: this.titlePopupElement,
        nzContent: ConfirmComponent,
        nzStyle: { top: '20px' },
        nzMaskClosable: false
      });
      this.detailDialogRef.afterClose.subscribe((result) => {
        if (result) {
          this.staffService.deleteMulti(this.listPersonSelected).subscribe((res: any) => {
            this.notification(res);
            this.reload();
          });
        }
      });
    } else {
      this.msg.warning('Bạn chưa chọn dữ liệu để xóa');
    }
  }
  hanlderCheckedId(event) {
    let list = [];
    event.forEach(element => {
      list.push(element);
    });
    this.listCheckId= list;
    if(this.listCheckId.length > 0){
      this.pageOptBtn_2[1].disabled = false;
      this.pageOptBtn_2[2].disabled = false;
    }else{
      this.pageOptBtn_2[1].disabled = true;
      this.pageOptBtn_2[2].disabled = true;
    }
  }
  hanlderAddTag(value: any){
    this.titlePopup= 'Cài đặt nhãn';
    this.isResizdePopup = false;
    this.heightModal = 'auto',
    this.widthModal = 600 +'px',
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: AddTagComponent,
      nzStyle: { top: '50px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
      },
      nzWidth: 600,
      nzComponentParams: {
        value: value
      },
    });
    // const instance = dialogRef.getContentComponent();
    this.detailDialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }
  hanlderAddListTag(){
    this.hanlderAddTag(this.listCheckId);
  }
  openMailDetail(event){
    this.titlePopup = 'Chi tiết thư';
    this.isResizdePopup = false;
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px',
    this.widthModal = 1300 +'px',
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: MailDetailComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height:  this.heightModal,
      },
      nzWidth: 1300,
      nzComponentParams: {
        value: event,
        mode: this.mode,
      },
    });
    this.detailDialogRef.afterClose.subscribe(() => {
      setTimeout(() => {
      this.reload();
      }, 50);
    });
  }
  openNewMail(event){
    this.isResizdePopup = false;
    this.titlePopup = 'Thư mới';
    this.getDetailOutboxMail(event.id);
  }
  getDetailOutboxMail(id){
    this.mailService.getMailOutboxById(id).subscribe((res)=>{
      this.mailDetail = res;
      this.getMailfile(res.id);
    });
  }
  getMailfile(id: number){
    this.mailService.getListFiles(id).subscribe((res)=>{
      this.fileList = res.result.map(x => ({
        uid : x.id,
        name : x.fileName,
        status : 'done'
      }));
      this.openPopupNewMail(id);
    });

  }
  openPopupNewMail(id){
    this.isResizdePopup = false;
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px',
    this.widthModal = 1300 +'px',
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpComposeComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1300,
      nzComponentParams: {
        mode: 'forward',
        id: id,
        data: this.mailDetail,
        filesRes: this.fileList,
        type: this.mode,
      },
    });
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = this.widthModal;
    let height =  this.heightModal;
    let top = 30;
    if(this.isResizdePopup === true){
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.detailDialogRef.updateConfig({
      nzWidth: width,
      nzStyle: {
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        height: height,
      }
    });
  }
}
